module.exports = __webpack_public_path__ + "1792395595471/images/logo_light.bbd6e65.png";